import { useEffect, useState, type ReactElement } from 'react';
import { api, type Kategoria } from '../api';

/**
 * Wybór kategorii urządzenia. Kategorie tworzą drzewo (pakiet branżowy, CLAUDE.md §8.3),
 * a `<select>` drzewa nie umie — więc płaszczymy je z wcięciem, zachowując kolejność
 * od korzenia do liści.
 */
export function WyborKategorii({
  wartosc,
  onZmiana,
  etykieta = 'Kategoria',
}: {
  wartosc: string;
  onZmiana: (categoryId: string) => void;
  etykieta?: string;
}) {
  const [kategorie, setKategorie] = useState<Kategoria[] | null>(null);

  useEffect(() => {
    api
      .kategorie()
      .then((wynik) => setKategorie(wynik.kategorie))
      .catch(() => setKategorie([]));
  }, []);

  return (
    <label className="block">
      <span className="t-label mb-5 block text-n-700">{etykieta}</span>
      <select
        value={wartosc}
        onChange={(zdarzenie) => onZmiana(zdarzenie.target.value)}
        className="w-full border border-n-300 bg-surface px-13 text-n-900"
      >
        <option value="">— wybierz —</option>
        {kategorie?.flatMap((korzen) => splaszcz(korzen, 0))}
      </select>
    </label>
  );
}

/** Kategorie jako płaska lista z wcięciem — drzewo w `<select>` inaczej się nie da. */
function splaszcz(kategoria: Kategoria, poziom: number): ReactElement[] {
  return [
    <option key={kategoria.id} value={kategoria.id}>
      {`${'  '.repeat(poziom)}${kategoria.nazwa}`}
    </option>,
    ...(kategoria.dzieci ?? []).flatMap((dziecko) => splaszcz(dziecko, poziom + 1)),
  ];
}
